import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WarehouseDictionaryWithAccess } from "../WarehouseDictionary/WarehouseDictionaryWithAccess";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { ICON_TYPE, INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { Textbox } from "components/Textbox/Textbox";
import { Button } from "components/Button/Button";


interface WarehouseData {
  WarehouseId?: string;
  WarehouseTitle?: string;
  WarehouseDetailsCount?: number;
  WarehouseDetailId?: string;
  WarehouseDetail?: string;
}

interface ItemData {
  Code?: string;
  Item?: string;
}

interface DetailPriceData {
  ItemTechnicalCode: string;
  Price: number;
  Discount: number;
  SubTotalPrice: number;
  Qty1: number;
  Qty2: number;
  TaxRate: number;
}

interface Props {
  mode: "view" | "edit" | 'create'; // You can change the mode types if necessary
  resetForm:any;
  setWarehouseData: (e) => void;
  setDetailPriceData: (e) => void;
  fetchPriceListDetail: (e ,i) => void;
  setUserChanges: (e) => void;
  setShowTree: (e) => void;
  setItemData: (e) => void;
  warehouseData:any;
  detailPriceData:any;
  itemData:any;
  jobId?:string
}

const ItemSelector: React.FC<Props> = ({setItemData,setDetailPriceData,  jobId,detailPriceData, itemData,mode, resetForm ,setWarehouseData ,warehouseData  ,fetchPriceListDetail ,setUserChanges ,setShowTree}) => {




  return (
    <div className="row">

      {(warehouseData || mode=='create') && <>
      <div className="col-lg-1">
        <WarehouseDictionaryWithAccess
          name="Warehouse"
          label="Warehouse"
          resetForm={resetForm}
          value={warehouseData?.WarehouseId}
          onChange={(e, obj) => {
            setWarehouseData({
              WarehouseId: e,
              WarehouseTitle: obj?.Name?.Description,
              WarehouseDetailsCount: obj?.Name?.WarehouseDetailsCount,
            });
            if (e !== warehouseData?.WarehouseId) {
              setItemData(null);
              setUserChanges({});
              setDetailPriceData({
                Price: 0,
                Discount: 0,
                SubTotalPrice: 0,
                Qty1: 1,
                Qty2: 1,
                TaxRate: 0,
              });
            }
          }}
          mode={jobId?'view':mode}
          required={true}
        />
      </div>

      {(warehouseData?.WarehouseDetailsCount > 0 || warehouseData?.WarehouseDetailId) && (
        <div className="col-lg-2">
          <DictionarySelectBox
            name="WarehouseDetail"
            label="WarehouseDetail"
            params={{ warehouseId: warehouseData?.WarehouseId }}
            onChange={(e, obj) => {
              setWarehouseData((prev) => ({
                ...prev,
                WarehouseDetailId: e,
                WarehouseDetail: obj?.Name,
              }));
            }}
            baseUrl={INVENTORYANDSALES_URL}
            endPoint={ENDPOINTSINVENTORYANDSALES.Inventory.BaseInformationApi.WarehouseDetail.dictionary}
            value={warehouseData?.WarehouseDetailId}
            resetForm={resetForm}
            mode={jobId?'view':mode}
          />
        </div>
      )}
      </>}

      {warehouseData && (
        <div className="col-lg-3" style={{ display: "flex", alignItems: "center", flexDirection: "row" }}>
          <Textbox
            required
            onBlurHandler={(e) => {
              if (e && e !== itemData?.Code) {
                fetchPriceListDetail(null, e);
              }
            }}
            Change={setUserChanges}
            textboxName={"itemCode"}
            textboxType="text"
            resetForm={resetForm}
            labelText={"itemCode"}
            mode={jobId?'view':mode}
            value={itemData?.Code}
            defaultValue={itemData?.Code}
            onChange={(e) => {
              if (!e.target.value) {
                setItemData({});
              }
            }}
          />
          {mode !== "view" && (
            <div style={{ marginTop: "4px", width: "10%" }}>
              <Button
                Icon={true}
                value={
                  <button
                    onClick={() => setShowTree(true)}
                    type="button"
                    className="checkButton d-flex align-items-center justify-content-center"
                  >
                    <FontAwesomeIcon icon={[ICON_TYPE, "diagram-project"]} size="1x" />
                  </button>
                }
                btnType="primary"
                onClick={() => setShowTree(true)}
              />
            </div>
          )}
        </div>
      )}

      <div className="col-lg-4">
        <Textbox
          withChangeDir={true}
          Change={setUserChanges}
          textboxName="Item"
          textboxType="text"
          labelText="ItemDescription"
          value={itemData?.Item}
          defaultValue={itemData?.Item}
          resetForm={resetForm}
          mode={jobId?'view':mode}
          required={false}
        />
      </div>

      <div className="col-lg-2">
        <Textbox
          Change={setUserChanges}
          textboxName="ItemTechnicalCode"
          textboxType="text"
          labelText="TechnicalCode"
          value={detailPriceData.ItemTechnicalCode + ""}
          defaultValue={detailPriceData.ItemTechnicalCode}
          resetForm={resetForm}
          mode={jobId?'view':mode}
          required={false}
        />
      </div>
    </div>
  );
};

export default ItemSelector;
